import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import authHeader from '../authHeader';

const base_url =window.location.origin+"/";


export const saveMilestoneConfig = createAsyncThunk(
    'save-milestone-config',
    async (payload,{rejectWithValue}) =>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Configuration/SaveMileStoneModeConfigSettings`,
                payload,
            {headers:authHeader()}
            )
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data);
            }else{
                return rejectWithValue(error.response);
            }
        }
    }
);

export const getMilestoneConfig = createAsyncThunk(
    'get-milestone-config',
    async (payload,{rejectWithValue}) =>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Configuration/GetMileStoneModeSettings`,
                payload,
            {headers:authHeader()}
            )
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data);
            }else{
                return rejectWithValue(error.response);
            }
        }
    }
);